import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpXsrfTokenExtractor
} from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@environment';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';

export const httpInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const router = inject(Router);
  const requestWithCredentials = req.clone({ withCredentials: true });
  const getCurrentPath = (): string => {
    const urlTree = router.parseUrl(router.url);
    urlTree.queryParams = {};
    return urlTree.toString();
  };

  const handleUnauthenticatedError = (): void => {
    const path = getCurrentPath();
    const errorMsgWhenNavigatingFails = 'Error while navigating to login page: ';

    router
      .navigate(['/login'], { queryParams: { redirectUrl: path } })
      .catch((e) => console.error(errorMsgWhenNavigatingFails + e));
  };

  return next(requestWithCredentials).pipe(
    catchError((e) => {
      const isHandlingRequired = e.status === 401 || e.status === 404;
      if (e instanceof HttpErrorResponse && isHandlingRequired) {
        switch (e.status) {
          case 401:
            handleUnauthenticatedError();
            break;
          case 404:
            window.location.href = environment.apiUrl + '/error/404.html?base=' + environment.frontendUrl;
            break;
        }
      }
      throw e;
    })
  );
};

export const httpsCsrfInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const tokenExtractor = inject(HttpXsrfTokenExtractor);
  const token = tokenExtractor.getToken();
  const requestToForward = token != null && req.url.startsWith(environment.apiUrl)
  ? req.clone({ setHeaders: { 'X-XSRF-TOKEN': token } })
  : req;
  return next(requestToForward);
};
